import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { navItemsForLevel } from "@/app/routes/nav";
import { useAccessLevel } from "@/features/access/AccessLevelContext";

type MainNavProps = {
  readonly className?: string;
  readonly listClassName?: string;
  readonly linkClassName?: string;
  readonly activeClassName?: string;
  readonly dataTestId?: string;
};

export function MainNav({
  className,
  listClassName,
  linkClassName = "nbs-mainnav__link",
  activeClassName = "nbs-mainnav__link--active",
  dataTestId,
}: MainNavProps) {
  const { t } = useTranslation();
  const { level } = useAccessLevel();
  const visible = navItemsForLevel(level);

  return (
    <nav
      className={className ?? "nbs-mainnav"}
      aria-label={t("shell.mainNav")}
      data-testid={dataTestId}
    >
      <ul className={listClassName ?? "nbs-mainnav__list"}>
        {visible.map((item) => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              {...(item.end ? { end: true } : {})}
              data-tour={
                item.path === "/"
                  ? "nav-home"
                  : `nav-${item.path.replace(/^\//, "").replace(/\//g, "-")}`
              }
              className={({ isActive }) =>
                `${linkClassName}${isActive ? ` ${activeClassName}` : ""}`
              }
            >
              {t(item.labelKey)}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
